// Analytics consent and event helpers.
//
// Nothing here loads a tracker. It records whether the visitor agreed, tells the
// rest of the app when that changes, and queues events until a tracker exists.

const KEY = 'cookieConsent';
const EVENT = 'safarnamah:consent';

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null; // private mode: treat as undecided rather than consented
  }
};

export const hasConsent = () => getConsent() === 'accepted';

export const setConsent = (value) => {
  try {
    localStorage.setItem(KEY, value);
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
  } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
};

export const onConsentChange = (handler) => {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};

// Declining should not just stop new cookies, it should clear the ones already
// set. Google's are readable from JS and scoped to the registrable domain.
export const clearAnalyticsCookies = () => {
  const host = window.location.hostname;
  const domains = [host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    if (!/^(_ga|_gid|_gat|_hj|_fb)/.test(name)) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${d}`;
    });
    document.cookie = `${name}=; Max-Age=0; path=/`;
  });
};

// Events fired before the tracker loads would otherwise be lost, so hold them.
const queue = [];

export const track = (name, params = {}) => {
  if (!hasConsent()) return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
    return;
  }
  if (queue.length < 20) queue.push([name, params]);
};

export const flushQueuedEvents = () => {
  if (typeof window.gtag !== 'function' || !hasConsent()) return;
  while (queue.length) {
    const [name, params] = queue.shift();
    window.gtag('event', name, params);
  }
};
